/**
 * Лимит параллельных просмотров платного контента (спека
 * 2026-10-02-parallel-view-limit-design.md, «Решения Бориса»): 1..3
 * устройства или «Без лимита» (null), по умолчанию 3. Границы совпадают с
 * бэкендом (PARALLEL_PREMIUM_VIEW_LIMIT).
 */
export const PARALLEL_LIMIT_OPTIONS = [1, 2, 3] as const;

export const DEFAULT_PARALLEL_LIMIT = 3;

/** Значение пункта «Без лимита» в селекте (MUI не принимает null). */
export const NO_LIMIT_OPTION = "none";

export type ParallelLimitValue = number | null;

/**
 * Значение с сервера: null это выключенный лимит, отсутствующее поле
 * читается как 3, сломанные числа приводятся к 1..3.
 */
export function normalizeParallelLimit(
  value: number | null | undefined
): ParallelLimitValue {
  if (value === null) return null;
  if (value === undefined || !Number.isFinite(value)) {
    return DEFAULT_PARALLEL_LIMIT;
  }
  return Math.min(3, Math.max(1, Math.trunc(value)));
}

/** Значение для MUI-селекта. */
export function toSelectValue(limit: ParallelLimitValue): string {
  return limit === null ? NO_LIMIT_OPTION : String(limit);
}

/** Значение из MUI-селекта. */
export function fromSelectValue(value: string): ParallelLimitValue {
  return value === NO_LIMIT_OPTION
    ? null
    : normalizeParallelLimit(Number(value));
}
